import { Component, OnInit, HostListener, Renderer2, ViewChild } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Observer } from 'rxjs/Observer';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import { SharedService } from 'app/shared/services/shared.service';
import { HttpService } from 'app/shared/services/http.service';
import { ListService } from 'app/shared/services/list.service';
import { UserService } from 'app/shared/services/user.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GridService } from 'app/shared/services/grid.service';
import { SupplyService } from 'app/shared/services/supply.service';
import { DemandService } from 'app/shared/services/demand.service';
import { ModalsService } from 'app/shared/services/modals.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';
import { GridComponent } from 'app/shared/components/grid/grid.component';
import { ListType } from 'app/types';
import { MAX_SCHAIN_NODES, MAX_SCHAIN_CSV_ROW_LENGTH, SCHAIN_CSV_HEADER_KEY_NAMES, SCHAIN_CSV_HEADER_SCHAIN_NAMES } from '../../rtb_partners/new-rtb-partner/rtb-partners.constants';
import { convertListItemsToSchains,parseSchainCSVFile as parseSchainCSVFileUtil } from '../../../../utils';

@AutoUnsubscribe()
@Component({
  selector: 'new-list-component',
  templateUrl: './new-list.component.html',
  styleUrls: ['./new-list.component.scss'],
})
export class NewListComponent implements OnInit {
  public listData: any;
  public listDataItems: Array<any>;
  public listDataItemsChanged: boolean;
  public originalData: any;
  public editMode: boolean;
  public routeParams: any;
  public getListResponse: any;
  public listTypes: Array<any>;
  public files: Array<any>;
  public searchString: string;
  public addToListString: string;
  public searchIsLoading: boolean;
  public searchResults: Array<any>;
  public searchResultsToggleState: boolean;
  public searchResultsMouseActive: boolean;
  @ViewChild(GridComponent) effectiveForGrid: GridComponent;
  public effectiveForToggleState: boolean;
  public effectiveForData: Array<any>;
  public effectiveForDataWhite: Array<any>;
  public effectiveForDataBlack: Array<any>;
  public effectiveForTabsData: Array<any>;
  public effectiveForSelectedTab: number;
  public effectiveForColumnsSettings: Array<any>;
  public effectiveForIsLoading: boolean;
  public effectiveForIsError: boolean;
  public effectiveForListChanged: boolean;
  public filtersForGrid: any;
  public affectedEntitiesData: Array<any>;
  public allSupplyData: Array<any>;
  public allDemandData: Array<any>;
  public activeEntities: boolean;
  public maxListContentToShowLimit = 10000;
  public selectedListItems: Array<any>;
  public shiftKeyIsDown: boolean;
  public ctrlKeyIsDown: boolean;
  public selectionRect: any;
  public mouseIsDown: boolean;
  public mouseMoveListener: any;
  public mouseUpListener: any;
  public isLoading: boolean;
  public subscriptions: Array<any>;
  public uploadFileSizeLimit: number;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public sanitizer: DomSanitizer,
    public renderer: Renderer2,
    public sharedService: SharedService,
    public httpService: HttpService,
    public listService: ListService,
    public userService: UserService,
    public dictionaryService: DictionaryService,
    public gridService: GridService,
    public supplyService: SupplyService,
    public demandService: DemandService,
    public modalsService: ModalsService,
    public ga: GoogleAnalyticsService
  ) {
    this.listData = {};
    this.listDataItems = [];
    this.listDataItemsChanged = false;
    this.originalData = {};
    this.editMode = false;
    this.routeParams = {};
    this.getListResponse = {};
    this.listTypes = [];
    this.searchString = '';
    this.addToListString = '';
    this.searchIsLoading = false;
    this.searchResults = [];
    this.searchResultsToggleState = false;
    this.searchResultsMouseActive = false;
    for (let i = 0; i < this.listService.listTypes.length; i++) {
      if (this.listService.listTypes[i].active) {
        if (this.listService.listTypes[i].featureFlag) {
          if (this.userService.getFeatureState(this.listService.listTypes[i].featureFlag)) {
            this.listTypes.push(this.listService.listTypes[i]);
          }
        } else {
          this.listTypes.push(this.listService.listTypes[i]);
        }
      }
    }
    this.files = [];
    this.effectiveForToggleState = true;
    this.effectiveForData = [];
    this.effectiveForDataWhite = [];
    this.effectiveForDataBlack = [];
    this.effectiveForTabsData = [];
    this.effectiveForSelectedTab = 0;
    this.effectiveForListChanged = false;
    this.effectiveForColumnsSettings = [
      { key: '$$selected', label: 'ASSIGNED' },
      { key: '$$disabled', label: '' },
      { key: 'id', label: 'ID', filterType: 'INPUT' },
      { key: 'name', label: 'NAME', filterType: 'INPUT' },
      { key: 'partner', label: 'PARTNER_NAME', filterType: 'SELECT' },
      { key: 'type', label: 'TYPE', filterType: 'SELECT' },
      {
        key: 'active',
        label: 'ACTIVE',
        parseFunction: this.gridService.parseActive,
        parseTooltipFunction: this.gridService.parseActiveTooltip,
      },
    ];
    this.effectiveForIsLoading = true;
    this.effectiveForIsError = false;
    this.filtersForGrid = {};
    this.allSupplyData = [];
    this.allDemandData = [];
    this.activeEntities = true;
    this.selectedListItems = [];
    this.shiftKeyIsDown = false;
    this.ctrlKeyIsDown = false;
    this.selectionRect = { xStart: null, yStart: null, xEnd: null, yEnd: null };
    this.mouseIsDown = false;
    this.isLoading = true;
    this.subscriptions = [];
  }

  ngOnDestroy() { }

  ngOnInit() {
    if (this.activeEntities) {
      this.filtersForGrid.active = [this.activeEntities];
    }
    this.subscriptions.push(
      this.route.params.subscribe((params) => {
        if (params.id && params.id !== 'new') {
          this.sharedService.setPageTitle('EDIT_LIST');
          this.routeParams.id = params.id;
          this.subscriptions.push(
            this.getList().subscribe(() => {
              this.onListTypeChanged();
            })
          );
        } else {
          this.sharedService.setPageTitle('NEW_LIST');
          this.subscriptions.push(
            this.getOtherData().subscribe(() => {
              this.initListData().subscribe(() => {
                this.onListInitialized();
              });
            })
          );
        }
      })
    );
    this.subscriptions.push(
      this.sharedService.getMessagesBus().subscribe((response: any) => {
        if (response.type === 'NETWORK_CHANGE') {
          if (this.editMode && !response.data.forcedChange) {
            this.originalData = _.cloneDeep(this.listData);
            //this.close();
          } else {
            this.isLoading = true;
            this.subscriptions.push(
              this.getOtherData().subscribe(() => {
                this.initListData().subscribe(() => {
                  this.onListInitialized();
                });
              })
            );
          }
        } else if (response.type === 'GRID_VALUE_CHANGE') {
          this.onSelectChange(response.data.dataItem);
        } else if (response.type === 'GRID_SELECTION_CHANGE_ATTEMPT') {
          this.onSelectAllChange(response.data);
        } else if (response.type === 'GRID_SELECTION_CHANGE') {
          this.onSelectAllConfirm(response.data);
        }
      })
    );
  }

  getList() {
    return Observable.create((observer: Observer<any>) => {
      let listId: number;
      if (this.routeParams.id) {
        listId = parseInt(this.routeParams.id);
      } else if (this.listData.id) {
        listId = parseInt(this.listData.id);
      }
      if (listId) {
        this.subscriptions.push(
          this.httpService.post('restriction_lists/getList', { id: listId }).subscribe(
            (response: any) => {
              if (response.errors) {
                this.onListNotFound();
              } else {
                this.editMode = true;
                this.getListResponse = response.list;
                const initDataObservable = this.initListData();
                const otherDataObservable = this.getOtherData();
                this.subscriptions.push(
                  forkJoin(initDataObservable, otherDataObservable).subscribe(() => {
                    //TODO: write here when everything is finished.
                    this.onListInitialized();
                    observer.next(true);
                    observer.complete();
                  })
                );
                this.userService.changeNetworkIfNeeded(response);
              }
            },
            (error: any) => {
              // Display the error message
              this.onListNotFound();
            }
          )
        );
      } else {
        this.onListNotFound();
      }
    });
  }

  getListContent() {
    return Observable.create((observer: Observer<any>) => {
      let listId: number;
      if (this.routeParams.id) {
        listId = parseInt(this.routeParams.id);
      } else if (this.listData.id) {
        listId = parseInt(this.listData.id);
      }
      if (listId) {
        const subscription = this.httpService.get('restriction_lists/getRestrictionListFile/' + listId, {});
        subscription.subscribe((response: any) => {
          if (response.data) {
            const items = _.map(_.compact(response.data.split('\n')), (i) => {
              const item = { display: '', selected: false };
              item.display = i;
              return item;
            });
            observer.next(items);
          } else {
            observer.next([]);
          }
          observer.complete();
        });
        this.subscriptions.push(subscription);
        return subscription;
      }
    });
  }

  getOtherData() {
    return Observable.create((observer: Observer<any>) => {
      const observablesArr: Array<Observable<any>> = [];
      observablesArr.push(this.getSupplies());
      observablesArr.push(this.getDemands());
      if (this.editMode) {
        observablesArr.push(this.getAffectedEntities());
      }
      forkJoin(observablesArr).subscribe(([r1, r2, r3]) => {
        observer.next(true);
        observer.complete();
      });
    });
  }

  getSupplies() {
    const params: any = {};
    if (this.activeEntities !== null) {
      params.activeSupplies = this.activeEntities ? 1 : 0;
    }
    params.countLists = 1;
    return Observable.create((observer: Observer<any>) => {
      const subscribe = this.httpService.post('vdsp_ws/getSupplies', params).subscribe(
        (response: any) => {
          let allSuppliesData: Array<any>;
          if (response) {
            allSuppliesData = response;
            allSuppliesData.forEach((supply: any) => {
              if (!this.sharedService.isEmpty(supply.parentNetworkName)) {
                supply.partner = supply.parentNetworkName;
              }
            });
            this.allSupplyData = allSuppliesData;
          }
          observer.next(true);
          observer.complete();
        },
        (error: any) => {
          // Display the error message
          this.effectiveForIsLoading = false;
          this.effectiveForIsError = true;
          observer.error(true);
          observer.complete();
        }
      );
      this.subscriptions.push(subscribe);
    });
  }

  getDemands() {
    const params: any = {};
    if (this.activeEntities !== null) {
      params.activeDemands = this.activeEntities ? 1 : 0;
    }
    params.countLists = 1;
    return Observable.create((observer: Observer<any>) => {
      const subscribe = this.httpService.post('vdsp_ws/getDemands', params).subscribe(
        (response: any) => {
          let allDemandData: Array<any>;
          if (response) {
            allDemandData = response;
            allDemandData.forEach((supply: any) => {
              if (!this.sharedService.isEmpty(supply.parentNetworkName)) {
                supply.partner = supply.parentNetworkName;
              }
            });
            this.allDemandData = allDemandData;
          }
          observer.next(true);
          observer.complete();
        },
        (error: any) => {
          // Display the error message
          this.effectiveForIsLoading = false;
          this.effectiveForIsError = true;
          observer.error(true);
          observer.complete();
        }
      );
      this.subscriptions.push(subscribe);
    });
  }

  getAffectedEntities() {
    return Observable.create((observer: Observer<any>) => {
      const subscribe = this.httpService
        .post('restriction_lists/getEffectedEntitiesList', { listId: this.routeParams.id })
        .subscribe(
          (response: any) => {
            this.affectedEntitiesData = response;
            //TODO: write here what to do with the affected list
            observer.next(true);
            observer.complete();
          },
          (error: any) => {
            //TODO: write here for error handling
            observer.error(true);
            observer.complete();
          }
        );
      this.subscriptions.push(subscribe);
    });
  }

  initListData() {
    return Observable.create((observer: Observer<any>) => {
      this.listData = this.editMode ? this.parseListResponse() : _.cloneDeep(this.listService.listModel);
      if (this.editMode && this.listData.numberOfItems <= this.maxListContentToShowLimit) {
        this.getListContent().subscribe((response: any) => {
          this.listDataItems = _.cloneDeep(response);
          observer.next(true);
          observer.complete();
        });
      } else {
        this.listDataItems = [];
        observer.next(true);
        observer.complete();
      }
    });
  }

  onListInitialized() {
    this.originalData = _.cloneDeep(this.listData);
    this.buildEffectiveForData();
    this.effectiveForIsLoading = false;
    this.isLoading = false;
    this.sharedService.setPageTitle('EDIT_LIST', this.listData.name);
  }

  buildEffectiveForData() {
    let currType: number;
    let typeName: any;
    let isEntitySelected: boolean;
    let isListLimitReached: boolean;
    let isDisabled: boolean;
    // Reset data
    this.effectiveForData = [];
    this.effectiveForDataWhite = [];
    this.effectiveForDataBlack = [];
    // Whitelist
    this.allSupplyData.forEach((currSupply: any) => {
      if (this.getEntityListType(currSupply) !== 2) {
        currType = parseInt(currSupply.type);
        if (currType !== 0) {
          typeName = _.find(this.supplyService.supplyTypes, (type: any) => {
            return type.id === currType;
          });
          typeName = typeName ? (typeName = ' (' + this.dictionaryService.get(typeName.name) + ')') : '';
          isEntitySelected = this.isEffected(currSupply.playerId, true, true);
          isListLimitReached =
            (currSupply.maxListLimitReached == '1' && this.listData.listType == ListType.BUNDLES_DOMAINS) ||
            (currSupply.ipListLimitReached == '1' && this.listData.listType == ListType.IP_ADDRESSES);
          isDisabled = !isEntitySelected && isListLimitReached;
          this.effectiveForDataWhite.push({
            $$selected: isEntitySelected,
            $$disabled: isDisabled,
            id: currSupply.playerId,
            name: currSupply.name,
            partner: currSupply.partner,
            type: this.dictionaryService.get('SUPPLY') + typeName,
            active: currSupply.active,
            $$link: '/supply/manage/' + currSupply.playerId,
          });
        }
      }
    });
    this.allDemandData.forEach((currDemand: any) => {
      if (this.getEntityListType(currDemand) !== 2) {
        currType = parseInt(currDemand.type);
        typeName = _.find(this.demandService.demandTypes, function (type: any) {
          return type.id === currType;
        });
        typeName = typeName ? (typeName = ' (' + this.dictionaryService.get(typeName.name) + ')') : '';
        isEntitySelected = this.isEffected(currDemand.vastId, false, true);
        isListLimitReached =
          (currDemand.maxListLimitReached == '1' && this.listData.listType == ListType.BUNDLES_DOMAINS) ||
          (currDemand.ipListLimitReached == '1' && this.listData.listType == ListType.IP_ADDRESSES);
        isDisabled = !isEntitySelected && isListLimitReached;
        this.effectiveForDataWhite.push({
          $$selected: isEntitySelected,
          $$disabled: isDisabled,
          id: currDemand.vastId,
          name: currDemand.name,
          partner: currDemand.partner,
          type: this.dictionaryService.get('DEMAND') + typeName,
          active: currDemand.active,
          $$link: '/demand/manage/' + currDemand.vastId,
        });
      }
    });
    // Blacklist
    this.allSupplyData.forEach((currSupply: any) => {
      if (this.getEntityListType(currSupply) !== 1) {
        currType = parseInt(currSupply.type);
        if (currType !== 0) {
          typeName = _.find(this.supplyService.supplyTypes, function (type: any) {
            return type.id === currType;
          });
          typeName = typeName ? (typeName = ' (' + this.dictionaryService.get(typeName.name) + ')') : '';
          isEntitySelected = this.isEffected(currSupply.playerId, true, false);
          isListLimitReached =
            (currSupply.maxListLimitReached == '1' && this.listData.listType == ListType.BUNDLES_DOMAINS) ||
            (currSupply.ipListLimitReached == '1' && this.listData.listType == ListType.IP_ADDRESSES);
          isDisabled = !isEntitySelected && isListLimitReached;
          this.effectiveForDataBlack.push({
            $$selected: isEntitySelected,
            $$disabled: isDisabled,
            id: currSupply.playerId,
            name: currSupply.name,
            partner: currSupply.partner,
            type: this.dictionaryService.get('SUPPLY') + typeName,
            active: currSupply.active,
            $$link: '/supply/manage/' + currSupply.playerId,
          });
        }
      }
    });
    this.allDemandData.forEach((currDemand: any) => {
      if (this.getEntityListType(currDemand) !== 1) {
        currType = parseInt(currDemand.type);
        typeName = _.find(this.demandService.demandTypes, function (type: any) {
          return type.id === currType;
        });
        typeName = typeName ? (typeName = ' (' + this.dictionaryService.get(typeName.name) + ')') : '';
        isEntitySelected = this.isEffected(currDemand.vastId, false, false);
        isListLimitReached =
          (currDemand.maxListLimitReached == '1' && this.listData.listType == ListType.BUNDLES_DOMAINS) ||
          (currDemand.ipListLimitReached == '1' && this.listData.listType == ListType.IP_ADDRESSES);
        isDisabled = !isEntitySelected && isListLimitReached;
        this.effectiveForDataBlack.push({
          $$selected: isEntitySelected,
          $$disabled: isDisabled,
          id: currDemand.vastId,
          name: currDemand.name,
          partner: currDemand.partner,
          type: this.dictionaryService.get('DEMAND') + typeName,
          active: currDemand.active,
          $$link: '/demand/manage/' + currDemand.vastId,
        });
      }
    });
    // Initialize the displayed data
    this.onListTypeChanged();
    this.updateEffectiveForDisplayedData();
  }

  updateEffectiveForDisplayedData() {
    this.effectiveForData =
      this.effectiveForSelectedTab === 0
        ? _.cloneDeep(this.effectiveForDataBlack)
        : _.cloneDeep(this.effectiveForDataWhite);
  }

  setTabsData() {
    const tabTitle = this.listData.listType === ListType.SCHAIN
      ? this.dictionaryService.get('DEMAND')
      : this.dictionaryService.get('BLACKLIST');
    const tabsData: Array<any> = [{ title: tabTitle }];
    const selectedTab = 0;
    if (this.listData.listType === ListType.BUNDLES_DOMAINS || this.listData.listType === ListType.URL_ADDRESSES) {
      tabsData.push({ title: this.dictionaryService.get('WHITELIST') });
    }
    this.effectiveForTabsData = tabsData;
    this.effectiveForSelectedTab = selectedTab;
  }

  onEffectiveForTabSelected($event: any) {
    this.effectiveForSelectedTab = $event;
    this.updateEffectiveForDisplayedData();
  }

  isEffected(affectedEntity: number, isSupply: boolean, isWhite: boolean) {
    return (
      _.find(this.affectedEntitiesData, {
        affectedEntity: affectedEntity,
        isSupply: isSupply ? '1' : '0',
        isWhite: isWhite ? '1' : '0',
      }) !== undefined
    );
  }

  getEntityListType(entity: any) {
    switch (this.listData.listType) {
      case ListType.IP_ADDRESSES:
        return parseInt(entity.ip_list_type);
      case ListType.BUNDLES_DOMAINS:
        return parseInt(entity.domain_list_type);
    }
    return 0;
  }

  onSelectChange(dataItem: any) {
    let listItem: any;
    this.effectiveForListChanged = true;
    if (this.effectiveForSelectedTab === 0) {
      listItem = _.find(this.effectiveForDataBlack, { id: dataItem.id, type: dataItem.type });
    } else if (this.effectiveForSelectedTab === 1) {
      listItem = _.find(this.effectiveForDataWhite, { id: dataItem.id, type: dataItem.type });
    }
    if (listItem) {
      listItem.$$selected = !listItem.$$selected;
    }
  }

  onSelectAllChange(allSelectedState: boolean) {
    const title: string = allSelectedState ? 'SELECT_ALL' : 'UNSELECT_ALL';
    this.modalsService.showModal({
      title: this.dictionaryService.get(title),
      component: 'confirm-assign',
      data: { state: allSelectedState },
    });
  }

  onSelectAllConfirm(data: Array<any>) {
    //let allSelectedState: boolean = data.length > 0 ? data[0].$$selected : false;
    const allSelectedState: boolean =
      this.effectiveForGrid.displayedData.length > 0 ? this.effectiveForGrid.displayedData[0].$$selected : false;
    let isDisplayed: boolean;
    if (this.effectiveForSelectedTab === 0) {
      this.effectiveForDataBlack.forEach((item: any) => {
        isDisplayed = _.find(this.effectiveForGrid.displayedData, { id: item.id, type: item.type });
        if (isDisplayed) {
          item.$$selected = allSelectedState;
        }
      });
    } else if (this.effectiveForSelectedTab === 1) {
      this.effectiveForDataWhite.forEach((item: any) => {
        isDisplayed = _.find(this.effectiveForGrid.displayedData, { id: item.id, type: item.type });
        if (isDisplayed) {
          item.$$selected = allSelectedState;
        }
      });
    }
    this.effectiveForListChanged = true;
  }

  parseListResponse() {
    const listData: any = {};
    listData.id = this.getListResponse.id;
    listData.name = this.getListResponse.name;
    listData.listType = parseInt(this.getListResponse.type);
    listData.listTypeName = _.find(this.listService.listTypes, { id: parseInt(this.getListResponse.type) }).name;
    listData.created = this.getListResponse.created;
    listData.updated = this.getListResponse.updated;
    listData.numberOfItems = this.getListResponse.list_items_counter;
    listData.usedBy = this.getListResponse.vasts_amount;
    listData.conditionType = 1; // TODO - black or white?
    //listData.effectiveForAll = false; // TODO - is effective for all
    listData.effectiveForAll = true; // TODO - is effective for all
    return listData;
  }

  onListNotFound() {
    this.originalData = _.cloneDeep(this.listData);
    this.router.navigate(['/list/manage']);
    this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_NOT_FOUND'), 'error');
  }

  fileChange($event: any) {
    this.files = $event;
  }

  hasChanges() {
    return !_.isEqual(this.listData, this.originalData) || this.effectiveForListChanged || this.listDataItemsChanged;
  }

  validateForm() {
    let isValid = true;
    if (this.sharedService.isEmpty(this.listData.name)) {
      isValid = false;
      this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_NAME_IS_REQUIRED'), 'error');
    } else if (this.files.length + this.listDataItems.length === 0 && this.listData.numberOfItems === 0) {
      isValid = false;
      this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_FILE_IS_REQUIRED'), 'error');
    }
    if (this.files.length > 0) {
      if (this.files[0].size > this.uploadFileSizeLimit * 1024 * 1024) {
        isValid = false;
        this.sharedService.showFlashMessage(
          this.dictionaryService.get('FILE_SIZE_EXCEED_ERROR')(this.uploadFileSizeLimit),
          'error'
        );
      }
    }
    return isValid;
  }

  onSearchChange($event: any) {
    if (!this.sharedService.isEmpty(this.searchString)) {
      this.search();
    }
  }

  search() {
    this.searchResults = this.sharedService.fastStringArrFilter(
      this.searchString,
      this.listDataItems,
      'display',
      false
    );
    this.toggleAllItems(false);
  }

  toggleListItem(item: any) {
    const isSelected: boolean = !item.selected;
    let startIndex: number;
    let endIndex: number;
    let temp: number;
    if (this.mouseIsDown) {
      item.selected = true;
    } else {
      if (!this.shiftKeyIsDown && !this.ctrlKeyIsDown) {
        this.searchResults.forEach((item: any) => {
          item.selected = false;
        });
        item.selected = true;
      } else if (this.ctrlKeyIsDown) {
        item.selected = isSelected;
      } else if (this.shiftKeyIsDown) {
        if (this.selectedListItems.length === 0) {
          startIndex = 0;
          endIndex = this.searchResults.indexOf(item);
        } else {
          startIndex = this.searchResults.indexOf(this.selectedListItems[this.selectedListItems.length - 1]);
          endIndex = this.searchResults.indexOf(item);
          if (endIndex < startIndex) {
            temp = startIndex;
            startIndex = endIndex;
            endIndex = temp;
          }
        }
        for (let i: number = startIndex; i <= endIndex; i++) {
          this.searchResults[i].selected = true;
        }
      }
    }
    this.updateSelectedItems();
  }

  updateSelectedItems() {
    this.selectedListItems = _.filter(this.searchResults, (item: any) => {
      return item.selected;
    });
  }

  onAddSuccess(addedItems: number) {
    this.sharedService.showFlashMessage(
      this.dictionaryService.get('ADDED_LIST_SUCCESS_MESSAGE')(addedItems),
      'success'
    );
  }

  onAddFailure(invalidItems: number) {
    this.sharedService.showFlashMessage(
      this.dictionaryService.get('ADDED_LIST_FAILURE_MESSAGE')(invalidItems),
      'error'
    );
  }

  onRemoveSuccess(removedDataCount: number) {
    this.sharedService.showFlashMessage(
      this.dictionaryService.get('REMOVED_LIST_SUCCESS_MESSAGE')(removedDataCount),
      'success'
    );
  }

  addToList(displayFlashMessage: boolean = true) {
    const itemsToAdd: Array<string> = this.addToListString.split(/\n/);
    let addedItems = 0;
    let invalidItems = 0;
    let isValid: boolean;
    // Remove empty lines
    _.remove(itemsToAdd, (item: string) => {
      return this.sharedService.isEmpty(item);
    });
    // For all of the new items...
    itemsToAdd.forEach((item: any) => {
      // Remove trailing spaces
      item = item.trim();
      // Reset the validity flag (valid if doesn't exist)
      isValid = !_.map(this.listDataItems, (item: any) => {
        return item.display.trim();
      }).includes(item);
      // Validate IP if needed
      if (parseInt(this.listData.listType) === ListType.IP_ADDRESSES && !this.sharedService.validateIP(item)) {
        isValid = false;
      }

      // Validate URL if needed
      if (parseInt(this.listData.listType) === ListType.URL_ADDRESSES && !this.sharedService.validateURL(item)) {
        isValid = false;
      }

      // If it's valid, add it; either way, add 1 to the relevant count
      if (isValid) {
        this.listDataItems.push({ display: item, selected: false });
        addedItems++;
      } else {
        invalidItems++;
      }
    });
    if (addedItems > 0 && displayFlashMessage) {
      this.onAddSuccess(addedItems);
    }
    if (invalidItems > 0 && displayFlashMessage) {
      this.onAddFailure(invalidItems);
    }
    this.listDataItemsChanged = !this.listDataItemsChanged ? addedItems > 0 : this.listDataItemsChanged;
    this.addToListString = '';
  }

  toggleAllItems(state: boolean) {
    _.map(this.listDataItems, (i) => {
      i.selected = state;
    });
    this.updateSelectedItems();
  }

  getSelectionRectStyle() {
    let width = 0;
    let height = 0;
    let top = -1;
    let left = -1;
    let minX: number;
    let maxX: number;
    let minY: number;
    let maxY: number;
    if (
      this.selectionRect.xStart !== null &&
      this.selectionRect.yStart !== null &&
      this.selectionRect.xEnd !== null &&
      this.selectionRect.yEnd !== null
    ) {
      minX = Math.min(this.selectionRect.xStart, this.selectionRect.xEnd);
      maxX = Math.max(this.selectionRect.xStart, this.selectionRect.xEnd);
      minY = Math.min(this.selectionRect.yStart, this.selectionRect.yEnd);
      maxY = Math.max(this.selectionRect.yStart, this.selectionRect.yEnd);
      top = minY;
      left = minX;
      width = maxX - minX;
      height = maxY - minY;
    }
    return this.sanitizer.bypassSecurityTrustStyle(
      `width: ` + width + `px; height: ` + height + `px; top: ` + top + `px; left: ` + left + `px;`
    );
  }

  removeListItems() {
    const selectedListItemsCount = this.selectedListItems.length;
    if (this.selectedListItems.length > 0) {
      _.remove(this.listDataItems, (i) => {
        return this.selectedListItems.indexOf(i) > -1;
      });
      _.remove(this.searchResults, (i) => {
        return this.selectedListItems.indexOf(i) > -1;
      });
      this.onRemoveSuccess(selectedListItemsCount);
      this.selectedListItems = [];
      this.listDataItemsChanged = true;
    }
  }

  removeAllListItems() {
    this.selectedListItems = this.searchResults;
    this.removeListItems();
    this.listDataItemsChanged = true;
  }

  saveListContent(saveParams: any) {
    return Observable.create((observer: Observer<any>) => {
      // update items
      let subscription: Observable<any>;
      if (this.listData.listType === ListType.IP_ADDRESSES) {
        // save data procedure for IP
        subscription = this.saveIPListContentProcedure(saveParams);
      } else if (this.listData.listType === ListType.BUNDLES_DOMAINS) {
        // save data procedure for domain
        subscription = this.saveDomainListContentProcedure(saveParams);
      } else if (this.listData.listType === ListType.URL_ADDRESSES) {
        // save data procedure for URLs
        subscription = this.saveURLListContentProcedure(saveParams);
      } else if (this.listData.listType === ListType.SCHAIN) {
        // save data procedure for schain
        subscription = this.saveSchainListContentProcedure(saveParams);
      }
      subscription.subscribe((result: any) => {
        observer.next(result);
        observer.complete();
      });
    });
  }

  saveIPListContentProcedure(saveParams: any) {
    return Observable.create((observer: Observer<any>) => {
      this.httpService
        .post('restriction_lists/uploadIPs', { rl_id: this.listData.id, list_items: saveParams.list_items })
        .subscribe(
          (response: any) => {
            if (response.status === 'OK') {
              observer.next(true);
              observer.complete();
            } else {
              this.onSaveError();
            }
          },
          (error: any) => {
            this.sharedService.showErrorFlashMessage();
            this.isLoading = false;
          }
        );
    });
  }

  saveIPListProcedure(saveParams: any, saveURL: string) {
    return Observable.create((observer: Observer<any>) => {
      this.subscriptions.push(
        this.httpService.post(saveURL, saveParams).subscribe(
          (response: any) => {
            if (!response.list.errors) {
              if (!this.editMode) {
                this.listData.id = response.list.id;
              }
              if (this.files.length > 0) {
                this.httpService
                  .upload('restriction_lists/uploadIPs', { rl_id: this.listData.id }, this.files[0])
                  .subscribe(
                    (response: any) => {
                      if (response.status === 'OK') {
                        this.sharedService.showFlashMessage(response.msg, 'info');
                        observer.next(response);
                        observer.complete();
                        this.onSaveSuccess();
                      } else {
                        this.sharedService.showFlashMessage(response.msg, 'error');
                        observer.next(false);
                        observer.complete();
                      }
                    },
                    (error: any) => {
                      this.sharedService.showFlashMessage(this.dictionaryService.get('NO_VALID_LIST_ITEMS'), 'error');
                      this.isLoading = false;
                    }
                  );
              } else {
                observer.next(response);
                observer.complete();
              }
            } else {
              if (response.list.errors.name) {
                this.sharedService.showFlashMessage(this.dictionaryService.get('NAME_ALREADY_EXISTS'), 'error');
              } else if (response.list.errors.limit) {
                this.sharedService.showFlashMessage(this.dictionaryService.get('IP_LISTS_REACH'), 'error');
              }
              this.isLoading = false;
              observer.next(false);
              observer.complete();
            }
          },
          (error: any) => {
            this.sharedService.showErrorFlashMessage();
            this.isLoading = false;
            observer.next(false);
            observer.complete();
          }
        )
      );
    });
  }

  saveDomainListContentProcedure(saveParams: any) {
    return Observable.create((observer: Observer<any>) => {
      this.httpService
        .post('restriction_lists/uploadDomains', {
          id: this.listData.id,
          list_items: saveParams.list_items,
          name: saveParams.name,
          type: saveParams.type,
        })
        .subscribe(
          (response: any) => {
            if (response.status === 'OK') {
              observer.next(true);
              observer.complete();
            } else {
              this.onSaveError();
            }
          },
          (error: any) => {
            this.sharedService.showErrorFlashMessage();
            this.isLoading = false;
          }
        );
    });
  }

  saveDomainListProcedure(saveParams: any, saveURL: string) {
    return Observable.create((observer: Observer<any>) => {
      if (this.files.length > 0) {
        this.subscriptions.push(
          this.httpService.upload('restriction_lists/uploadDomains', {}, this.files[0]).subscribe(
            (response: any) => {
              if (response.status.toLowerCase() !== 'error') {
                const uploadResponse: any = _.cloneDeep(response);
                saveParams.files = _.cloneDeep(response.files);
                this.httpService.post(saveURL, saveParams).subscribe(
                  (response: any) => {
                    if (!response.list.errors) {
                      if (!this.editMode) {
                        this.listData.id = response.list.id;
                        this.originalData = _.cloneDeep(this.listData);
                      }
                      this.sharedService.showFlashMessage(
                        this.dictionaryService.get('UPLOAD_DOMAINS_SUCCESS')(
                          uploadResponse.uploaded,
                          uploadResponse.invalid.bad + uploadResponse.invalid.empty + uploadResponse.invalid.duplicated
                        ),
                        'info'
                      );
                      observer.next(response);
                      observer.complete();
                    } else {
                      if (response.list.errors.name) {
                        this.sharedService.showFlashMessage(this.dictionaryService.get('NAME_ALREADY_EXISTS'), 'error');
                      } else {
                        this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_IS_EMPTY_ERROR'), 'error');
                      }
                      this.isLoading = false;
                    }
                  },
                  (error: any) => {
                    this.sharedService.showErrorFlashMessage();
                    this.isLoading = false;
                    observer.next(false);
                    observer.complete();
                  }
                );
              } else {
                this.sharedService.showFlashMessage(response.msg, 'error');
                this.isLoading = false;
                observer.next(false);
                observer.complete();
              }
            },
            (error: any) => {
              this.sharedService.showErrorFlashMessage();
              this.isLoading = false;
              observer.next(false);
              observer.complete();
            }
          )
        );
      } else {
        this.subscriptions.push(
          this.httpService.post(saveURL, saveParams).subscribe(
            (response: any) => {
              if (!response.list.errors) {
                if (!this.editMode) {
                  this.listData.id = response.list.id;
                  this.originalData = _.cloneDeep(this.listData);
                }
                observer.next(response);
                observer.complete();
              } else {
                if (response.list.errors.name) {
                  this.sharedService.showFlashMessage(this.dictionaryService.get('NAME_ALREADY_EXISTS'), 'error');
                } else {
                  this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_IS_EMPTY_ERROR'), 'error');
                }
                this.isLoading = false;
                observer.next(false);
                observer.complete();
              }
            },
            (error: any) => {
              this.sharedService.showErrorFlashMessage();
              this.isLoading = false;
              observer.next(false);
              observer.complete();
            }
          )
        );
      }
    });
  }

  saveURLListContentProcedure(saveParams: any) {
    return Observable.create((observer: Observer<any>) => {
      this.httpService
        .post('restriction_lists/uploadURLs', {
          id: this.listData.id,
          list_items: saveParams.list_items,
          name: saveParams.name,
          type: saveParams.type,
        })
        .subscribe(
          (response: any) => {
            if (response.status === 'OK') {
              observer.next(true);
              observer.complete();
            } else {
              this.onSaveError();
            }
          },
          (error: any) => {
            this.sharedService.showErrorFlashMessage();
            this.isLoading = false;
          }
        );
    });
  }

  saveURLListProcedure(saveParams: any, saveURL: string) {
    return Observable.create((observer: Observer<any>) => {
      if (this.files.length > 0) {
        this.subscriptions.push(
          this.httpService
            .upload('restriction_lists/uploadURLs', {}, this.files[0])
            .subscribe(
              (uploadResult: any) => {
                if (uploadResult.status.toLowerCase() !== 'error') {
                  const uploadResponse: any = _.cloneDeep(uploadResult);
                  saveParams.files = _.cloneDeep(uploadResponse.files);

                  this.httpService
                    .post(saveURL, saveParams)
                    .subscribe(
                      (postResponse: any) => {
                        if (!postResponse.list.errors) {
                          if (!this.editMode) {
                            this.listData.id = postResponse.list.id;
                            this.originalData = _.cloneDeep(this.listData);
                          }

                          observer.next(postResponse);
                          observer.complete();
                        } else {
                          if (postResponse.list.errors.name) {
                            this.sharedService.showFlashMessage(this.dictionaryService.get('NAME_ALREADY_EXISTS'), 'error');
                          } else {
                            this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_IS_EMPTY_ERROR'), 'error');
                          }

                          this.isLoading = false;
                        }
                      },
                      (error: any) => {
                        this.sharedService.showErrorFlashMessage();
                        this.isLoading = false;

                        observer.next(false);
                        observer.complete();
                      }
                    );
                } else {
                  this.sharedService.showFlashMessage(uploadResult.msg, 'error');
                  this.isLoading = false;

                  observer.next(false);
                  observer.complete();
                }
              },
              (error: any) => {
                this.sharedService.showErrorFlashMessage();
                this.isLoading = false;
                observer.next(false);
                observer.complete();
              }
            )
        );
      } else {
        this.subscriptions.push(
          this.httpService.post(saveURL, saveParams).subscribe(
            (response: any) => {
              if (!response.list.errors) {
                if (!this.editMode) {
                  this.listData.id = response.list.id;
                  this.originalData = _.cloneDeep(this.listData);
                }
                observer.next(response);
                observer.complete();
              } else {
                if (response.list.errors.name) {
                  this.sharedService.showFlashMessage(this.dictionaryService.get('NAME_ALREADY_EXISTS'), 'error');
                } else {
                  this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_IS_EMPTY_ERROR'), 'error');
                }
                this.isLoading = false;
                observer.next(false);
                observer.complete();
              }
            },
            (error: any) => {
              this.sharedService.showErrorFlashMessage();
              this.isLoading = false;
              observer.next(false);
              observer.complete();
            }
          )
        );
      }
    });
  }


  saveSchainListContentProcedure(saveParams: any) {
    return Observable.create((observer: Observer<any>) => {
      // Convert list_items to the format expected by server
      const schains = convertListItemsToSchains(saveParams.list_items);

      this.httpService
        .post('restriction_lists/uploadSchain', {
          schains: schains,
          name: this.listData.name
        })
        .subscribe(
          (response: any) => {
            if (response && response.status === 'OK') {
              if (response.list && response.list.id) {
                this.listData.id = response.list.id;
              }
              if (response.uploaded > 0) {
                this.sharedService.showFlashMessage(response.msg, 'info');
              }
              if (response.invalid && response.invalid.bad > 0) {
                console.warn('⚠️ Some invalid schains:', response.invalid.items);
              }
              this.onSaveSuccess();
              observer.next(true);
              observer.complete();
            } else {
              console.error('Schain upload failed:', response);
              const errorMsg = (response && response.msg) ? response.msg : 'Schain upload failed';
              this.sharedService.showFlashMessage(errorMsg, 'error');
              this.isLoading = false;
              observer.next(false);
              observer.complete();
            }
          },
          (error: any) => {
            this.sharedService.showErrorFlashMessage();
            this.isLoading = false;
            observer.next(false);
            observer.complete();
          }
        );
    });
  }

  parseSchainCSVFile(file: File): Promise<any[]> {
    return parseSchainCSVFileUtil(
      file,
      SCHAIN_CSV_HEADER_KEY_NAMES,
      SCHAIN_CSV_HEADER_SCHAIN_NAMES,
      MAX_SCHAIN_CSV_ROW_LENGTH,
      MAX_SCHAIN_NODES
    );
  }

  saveSchainListProcedure(saveParams: any, saveURL: string) {
    return Observable.create((observer: Observer<any>) => {
      if (this.files.length > 0) {
        this.parseSchainCSVFile(this.files[0]).then((schains: any[]) => {
          this.httpService
            .post('restriction_lists/uploadSchain', {
              schains: schains,
              name: this.listData.name
            })
            .subscribe(
              (uploadResult: any) => {
                if (uploadResult && uploadResult.status === 'OK') {
                  if (uploadResult.list && uploadResult.list.id) {
                    this.listData.id = uploadResult.list.id;
                  }

                  if (uploadResult.uploaded > 0) {
                    this.sharedService.showFlashMessage(uploadResult.msg, 'info');
                  }
                  if (uploadResult.invalid && uploadResult.invalid.bad > 0) {
                    console.warn('⚠️ Some invalid schains:', uploadResult.invalid.items);
                  }

                  // Since server handled the complete save, go directly to success
                  this.onSaveSuccess();
                  observer.next(true);
                  observer.complete();
                } else {
                  this.sharedService.showFlashMessage(uploadResult.msg || 'File processing failed', 'error');
                  this.isLoading = false;
                  observer.next(false);
                  observer.complete();
                }
              },
              (error: any) => {
                console.error('Schain file processing error:', error);
                this.sharedService.showErrorFlashMessage();
                this.isLoading = false;
                observer.next(false);
                observer.complete();
              }
            );
        }).catch((error) => {
          console.error('CSV parsing error:', error);
          const errorMessage = error !== null && error.message || 'Error parsing CSV file';
          this.sharedService.showFlashMessage(errorMessage, 'error');
          this.isLoading = false;
          observer.next(false);
          observer.complete();
        });
      } else {
        // No file, just save the manually entered data
        this.subscriptions.push(
          this.httpService.post(saveURL, saveParams).subscribe(
            (response: any) => {
              if (!response.list.errors) {
                if (!this.editMode) {
                  this.listData.id = response.list.id;
                  this.originalData = _.cloneDeep(this.listData);
                }
                observer.next(response);
                observer.complete();
              } else {
                if (response.list.errors.name) {
                  this.sharedService.showFlashMessage(this.dictionaryService.get('NAME_ALREADY_EXISTS'), 'error');
                } else {
                  this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_IS_EMPTY_ERROR'), 'error');
                }
                this.isLoading = false;
                observer.next(false);
                observer.complete();
              }
            },
            (error: any) => {
              this.sharedService.showErrorFlashMessage();
              this.isLoading = false;
              observer.next(false);
              observer.complete();
            }
          )
        );
      }
    });
  }

  effectiveForSaveProcedure() {
    return Observable.create((observer: Observer<any>) => {
      const saveParams: any = { whiteList: [], blackList: [], listId: this.listData.id, type: this.listData.listType };
      const selectedWhiteListArray = _.filter(this.effectiveForDataWhite, '$$selected');
      const selectedBlackListArray = _.filter(this.effectiveForDataBlack, '$$selected');
      saveParams.whiteList = _.map(selectedWhiteListArray, (l: any) => {
        return {
          affectedEntity: l.id,
          isSupply: l.type.indexOf('Supply') > -1 ? 1 : 0,
          isWhite: 1,
          name: this.listData.name,
        };
      });
      saveParams.blackList = _.map(selectedBlackListArray, (l: any) => {
        return {
          affectedEntity: l.id,
          isSupply: l.type.indexOf('Supply') > -1 ? 1 : 0,
          isWhite: 0,
          name: this.listData.name,
        };
      });
      this.httpService.post('restriction_lists/setEffectedEntitiesList', saveParams).subscribe((response: any) => {
        observer.next(true);
        observer.complete();
      });
    });
  }

  getTextAreaPlaceholder(listType: number): string {
    switch (listType) {
      case ListType.IP_ADDRESSES:
        return 'ADD_TO_LIST_PLACEHOLDER_IP';
      case ListType.BUNDLES_DOMAINS:
        return 'ADD_TO_LIST_PLACEHOLDER_BUNDLE';
      case ListType.URL_ADDRESSES:
        return 'ADD_TO_LIST_PLACEHOLDER_URL';
      case ListType.SCHAIN:
        return 'ADD_TO_LIST_PLACEHOLDER_SCHAIN';
      default:
        return 'ADD_TO_LIST_PLACEHOLDER_BUNDLE';
    }
  }

  onListTypeChanged() {
    // Remove invalid IPs for IP list
    switch (this.listData.listType) {
      case ListType.IP_ADDRESSES:
        this.listDataItems = _.filter(this.listDataItems, (item: any) => {
          const addresses: Array<string> = item.display.split(' ') || [];
          const ip1: string = addresses.length > 0 ? addresses[0] : null;
          const ip2: string = addresses.length > 1 ? addresses[1] : null;
          let valid = false;
          if (ip1 !== null) {
            valid = this.sharedService.validateIP(ip1);
          }
          if (valid && ip2 !== null) {
            valid = valid && this.sharedService.validateIP(ip2);
          }
          return valid;
        });
        break;
    }
    // Update the file size limit and the tabs data
    this.uploadFileSizeLimit = _.find(this.listTypes, { id: this.listData.listType }).maxFileSize;
    this.setTabsData();
    this.updateEffectiveForDisplayedData();
  }

  cancel() {
    this.router.navigate(['/list/manage']);
  }

  save() {
    const saveURL: string = this.editMode ? 'restriction_lists/updateList' : 'restriction_lists/saveList';
    const saveParams: any = { name: this.listData.name, type: this.listData.listType, list_items: [] };
    let subscription: Observable<any>;
    this.addToList(false);
    saveParams.list_items = _.map(this.listDataItems, (l: any) => {
      return l.display;
    });
    if (this.editMode) {
      saveParams.id = this.listData.id;
    }
    if (this.validateForm()) {
      this.isLoading = true;
      if (this.listData.listType === ListType.IP_ADDRESSES) {
        // IP
        subscription = this.saveIPListProcedure(saveParams, saveURL);
      } else if (this.listData.listType === ListType.BUNDLES_DOMAINS) {
        // Domains
        subscription = this.saveDomainListProcedure(saveParams, saveURL);
      } else if (this.listData.listType === ListType.URL_ADDRESSES) {
        // URLs
        subscription = this.saveURLListProcedure(saveParams, saveURL);
      } else if (this.listData.listType === ListType.SCHAIN) {
        // Schain - server handles complete save process, bypass traditional flow
        this.saveSchainDirectly(saveParams);
        return; // Exit early, don't continue with traditional save flow
      }

      subscription.subscribe((saveResponse: any) => {
        if (saveResponse) {
          const subscriptions = [];
          saveParams.id = this.listData.id;
          if (this.listDataItemsChanged) {
            if (this.listDataItems.length > 0) {
              subscriptions.push(this.saveListContent(saveParams));
              this.listDataItemsChanged = false;
            } else {
              this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_IS_EMPTY_ERROR'), 'error');
            }
          }
          if (this.effectiveForListChanged) {
            subscriptions.push(this.effectiveForSaveProcedure());
            this.effectiveForListChanged = false;
          }
          if (subscriptions.length > 0) {
            forkJoin(subscriptions).subscribe(() => {
              this.onSaveSuccess();
            });
          } else {
            this.onSaveSuccess();
          }
        } else {
          this.isLoading = false;
        }
      });
    }
  }

  saveSchainDirectly(saveParams: any) {
    if (this.listDataItemsChanged && this.listDataItems.length > 0) {
      // Manual entry - use saveSchainListContentProcedure
      this.saveSchainListContentProcedure(saveParams).subscribe(
        (success: boolean) => {
          if (!success) {
            this.isLoading = false;
          }
          // Success handling is done in the procedure itself
        },
        (error: any) => {
          console.error('Schain direct save error:', error);
          this.isLoading = false;
        }
      );
    } else if (this.files.length > 0) {
      // File upload - use saveSchainListProcedure
      this.saveSchainListProcedure(saveParams, '').subscribe(
        (success: boolean) => {
          if (!success) {
            this.isLoading = false;
          }
          // Success handling is done in the procedure itself
        },
        (error: any) => {
          console.error('Schain direct save error:', error);
          this.isLoading = false;
        }
      );
    } else {
      this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_IS_EMPTY_ERROR'), 'error');
      this.isLoading = false;
    }
  }

  close() {
    this.router.navigate(['/list/manage']);
  }

  onSaveSuccess() {
    this.originalData = _.cloneDeep(this.listData);
    this.addToListString = '';
    this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_SAVED_SUCCESSFULLY'), 'success');
    if (this.editMode) {
      this.subscriptions.push(
        this.getList().subscribe(() => {
          this.effectiveForListChanged = false;
          this.setTabsData();
          this.updateEffectiveForDisplayedData();
        })
      );
    } else {
      this.router.navigate(['/list/manage/', this.listData.id]);
      this.isLoading = false;
    }
  }

  onSaveError() {
    this.sharedService.showFlashMessage(this.dictionaryService.get('LIST_SAVE_ERROR'), 'error');
    this.isLoading = false;
  }

  downloadList() {
    this.subscriptions.push(
      this.httpService.post('restriction_lists/getRestrictionListFile/' + this.listData.id, {}).subscribe(
        (response: any) => {
          const blob = new Blob([response.data], { type: 'text/csv; charset=utf-8' });
          saveAs(blob, this.dictionaryService.get('LIST') + this.listData.id + '.txt');
        },
        (error: any) => {
          this.modalsService.showModal({
            component: 'new-list-component',
            title: this.dictionaryService.get('AN_ERROR_HAS_OCCURRED'),
          });
        }
      )
    );
  }

  downloadSampleSchainCSV() {
    const sampleContent = `key,schain
123456789,"example.net,1000001|example.com,2000001"
987654321,"example.net,1000002|example.com,2000002"`;
    const blob = new Blob([sampleContent], { type: 'text/csv; charset=utf-8' });
    saveAs(blob, 'schain-sample.csv');
  }

  intersect(elem1: any, elem2: any) {
    const r1: any = elem1.getBoundingClientRect();
    const r2: any = elem2.getBoundingClientRect();
    return !(r2.left > r1.right || r2.right < r1.left || r2.top > r1.bottom || r2.bottom < r1.top);
  }

  onFilterChange($event: any) {
    let activeEntities: boolean;
    if ($event.active) {
      activeEntities = $event.active.length === 1 ? $event.active[0] : null;
      if (activeEntities !== this.activeEntities) {
        this.activeEntities = activeEntities;
        this.effectiveForIsLoading = true;
        this.subscriptions.push(
          this.getOtherData().subscribe(() => {
            this.buildEffectiveForData();
            this.effectiveForIsLoading = false;
          })
        );
      }
    }
    this.filtersForGrid = _.cloneDeep($event);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick($event: any) {
    const path: any =
      $event.path || ($event.composedPath && $event.composedPath()) || this.sharedService.composedPath($event.target);
    const ids: Array<string> = _.without(_.map(path, 'id'), '', undefined);
    let searchResultsMouseActive = false;

    if (!ids.includes('searchWrapper')) {
      this.searchResultsToggleState = false;
    }

    if (this.searchResultsToggleState && this.searchResults.length > 0) {
      path.forEach((item: any) => {
        if (item.classList) {
          if (Array.from(item.classList).includes('searchResults')) {
            searchResultsMouseActive = true;
          }
        }
      });
    }

    this.searchResultsMouseActive = searchResultsMouseActive;
  }

  onMouseDown($event: any) {
    const searchResults: any = document.getElementsByClassName('searchResults');
    const offset: any = searchResults.length > 0 ? searchResults[0].getBoundingClientRect() : { top: 0, left: 0 };

    this.selectionRect = {
      xStart: this.sharedService.getMouseCoords($event, 'x') - offset.left,
      yStart: this.sharedService.getMouseCoords($event, 'y') - offset.top,
      xEnd: null,
      yEnd: null,
    };

    if (!this.shiftKeyIsDown && !this.ctrlKeyIsDown) {
      this.toggleAllItems(false);
    }

    this.mouseIsDown = true;
    this.mouseMoveListener = this.renderer.listen(document, 'mousemove', ($event: any) => {
      const searchResultsSelectionRect: HTMLElement = document.getElementById('searchResultsSelectionRect');
      const wrapper: any = document.getElementsByClassName('searchResults');
      const items: any = Array.from(document.getElementsByClassName('searchResult'));
      const moveOffset: any = wrapper.length > 0 ? wrapper[0].getBoundingClientRect() : { top: 0, left: 0 };

      if (this.selectionRect.xStart !== null && this.selectionRect.yStart !== null) {
        this.selectionRect.xEnd = this.sharedService.getMouseCoords($event, 'x') - moveOffset.left;
        this.selectionRect.yEnd = this.sharedService.getMouseCoords($event, 'y') - moveOffset.top;
        items.forEach((item: any, index: number) => {
          if (this.intersect(item, searchResultsSelectionRect)) {
            this.toggleListItem(this.searchResults[index]);
          }
        });
      }
    });

    this.mouseUpListener = this.renderer.listen(document, 'mouseup', () => {
      this.selectionRect = {
        xStart: null,
        yStart: null,
        xEnd: null,
        yEnd: null,
      };
      this.mouseIsDown = false;
      this.mouseUpListener();
      this.mouseMoveListener();
    });
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown($event: any) {
    switch ($event.which) {
      // Shift
      case 16:
        this.shiftKeyIsDown = true;
        break;
      // Ctrl
      case 17:
        this.ctrlKeyIsDown = true;
        break;
      // Delete
      case 46:
        this.removeListItems();
        break;
      // A/a
      case 65:
        if (this.ctrlKeyIsDown && this.searchResultsMouseActive) {
          this.toggleAllItems(true);
          $event.preventDefault();
          $event.stopPropagation();
        }
        break;
    }
  }

  @HostListener('document:keyup', ['$event'])
  onKeyUp($event: any) {
    switch ($event.which) {
      case 16:
        this.shiftKeyIsDown = false;
        break;
      case 17:
        this.ctrlKeyIsDown = false;
        break;
    }
  }
}
